import React from 'react';
import {connect} from 'react-redux';

import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';
import Talisman from '../Presentation/Talisman';

import DocumentTitle from 'react-document-title';
import buildTitle from '../../utils/TitleBuilder';

class AboutMeditation extends React.Component {
    render() {
        return <FullWidthPage title="За медитацията">
                <div className="col-md-12">
                    <SectionTitle>За медитацията</SectionTitle>

                    <p>Медитацията е умение като всяко друго и като всяко умение изисква практика. Също като фитнеса за
                        тялото, ние разглеждаме медитацията като тренировка за ума. Медитациите Медита нямат нищо общо с
                        религията, с някакви догми или с духовни течения. Те са практика, която с времето води до вътрешен
                        мир и спокойствие, до успкояване на ума, емоциите и тялото, до повече съзнателност и по-спокоен сън.
                        Живеем в динамични и информационни времена, в които ни се налага да работим и мислим на бързи
                        обороти и обикновено на няколко писти едновременно. Всичко това обаче има отражение върху здравето и
                        върху качеството ни на живот. Медитациите отварят пространство за нов тип съзнателност и
                        нереактивност, дават ни баланс и ни зареждат с енергия за предизвикателствата по пътя. Защото
                        най-добрият път не е най-бързият, а най-правилният. </p>

                        <Talisman />
                </div>
            </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(AboutMeditation);




// WEBPACK FOOTER //
// ./src/components/Pages/AboutMeditation.js